import React, { useContext, useEffect, useState } from 'react'
import SearchTable from 'src/components/searchTable'
import moment from 'moment'
import useAxios from 'axios-hooks'
import { SUBSCRIBER_API } from '../../../utils/urls'
import { AppContext } from '../../../context/app'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleDown, faEllipsisH } from '@fortawesome/free-solid-svg-icons'
import { CDropdown, CDropdownItem, CDropdownMenu, CDropdownToggle } from '@coreui/react'
import CIcon from '@coreui/icons-react'
import { cilClearAll, cilReload } from '@coreui/icons'
import ActivateDeactivateUser from '../common/activateDeactivate'
import ResetPasswordModal from '../common/resetPasswordModal'
import { PAGE_SIZE } from 'src/views/utils/constants'
import { isEmpty } from 'lodash'

const SubscriberList = () => {
  const { setLoader } = useContext(AppContext)
  const [searchText, setSearchText] = useState('')
  const [subscribers, setSubscribers] = useState([])
  const [userStatusModal, setUserStatusModal] = useState(false)
  const [resetPasswordModal, setResetPasswordModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState({})
  const [page, setPage] = useState(1)

  const [{ data: subscriberList, loading: subscriberListLoading }, subscriberListCall] = useAxios(
    {
      url: `${SUBSCRIBER_API}/list?page_size=${PAGE_SIZE}`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    subscriberListCall({
      params: {
        page: page,
        search_text: searchText,
      },
    })
  }, [])

  useEffect(() => {
    setLoader(subscriberListLoading)
  }, [subscriberListLoading])

  useEffect(() => {
    if (subscriberList && subscriberList.success) {
      page === 1
        ? setSubscribers(subscriberList.data)
        : setSubscribers((subscribers) => [...subscribers, ...subscriberList.data])
    }
  }, [subscriberList])

  const handleActivateDeactivate = (info) => {
    setSelectedUser(info)
    setUserStatusModal(true)
  }

  const handleResetPassword = (info) => {
    setSelectedUser(info)
    setResetPasswordModal(true)
  }

  const handleSearch = (value) => {
    setPage(1)
    setSearchText(value)
    subscriberListCall({
      params: {
        page_no: 1,
        search_text: `${value}`,
      },
    })
  }

  const tableConfig = [
    {
      header: 'Name',
      dataCell: (info) => info.name,
      width: 17,
    },
    {
      header: 'Email',
      dataCell: (info) => info.email_id,
      width: 25,
    },
    {
      header: 'Phone',
      dataCell: (info) => info.phone,
      width: 17,
    },
    {
      header: 'Status',
      dataCell: (info) => (info.status ? 'Active' : 'In Active'),
      width: 13,
    },
    {
      header: 'Created On',
      dataCell: (info) => moment.utc(info.created_date).format('DD-MM-YYYY'),
      width: 11,
    },
    {
      header: (
        <div className="d-flex justify-content-center">
          <FontAwesomeIcon icon={faAngleDoubleDown} size="lg" className="mx-1" />{' '}
        </div>
      ),

      dataCell: (info) => (
        <div className="d-flex justify-content-center">
          <CDropdown>
            <CDropdownToggle color="white" caret={false}>
              <FontAwesomeIcon icon={faEllipsisH} size="2x" />
            </CDropdownToggle>
            <CDropdownMenu>
              <CDropdownItem onClick={() => handleResetPassword(info)}>
                <CIcon icon={cilReload} size="sm" />
                {'  Reset Password'}
              </CDropdownItem>
              <CDropdownItem onClick={() => handleActivateDeactivate(info)}>
                <CIcon icon={cilClearAll} size="sm" />
                {!info.status ? ' Activate' : ' Deactivate'}
              </CDropdownItem>
            </CDropdownMenu>
          </CDropdown>
        </div>
      ),
      width: 9,
    },
  ]

  const handleNextPage = () => {
    subscriberListCall({
      params: {
        page: page + 1,
        search_text: searchText,
      },
    })
    setPage((page) => page + 1)
  }
  return (
    <>
      <h4>Subscriber List</h4>
      <p>{`Manage your Subscribers`}</p>
      <SearchTable
        type={`Subscribers`}
        tableCardHeight={65}
        disableButton={true}
        searchTerm={`name`}
        tableContent={subscribers}
        tableConfig={tableConfig}
        handleNextPage={handleNextPage}
        hashWidth={8}
        paginationEnable={
          subscriberList && !isEmpty(subscriberList.data) && subscriberList.total > page * PAGE_SIZE
        }
        searchCallback={handleSearch}
        totalTableContent={subscriberList?.total}
      />
      {userStatusModal && (
        <ActivateDeactivateUser
          user={selectedUser}
          showModal={userStatusModal}
          handleClose={() => setUserStatusModal(false)}
          successCallback={subscriberListCall}
        />
      )}
      {resetPasswordModal && (
        <ResetPasswordModal
          user={selectedUser}
          showModal={resetPasswordModal}
          handleClose={() => setResetPasswordModal(false)}
        />
      )}
    </>
  )
}

export default SubscriberList
